// import DateSelector from 'components/common/DateSelector';
import {parseISO} from 'date-fns';
import React, {useEffect, useState} from 'react';
import {formatDate} from 'utils/formator';
import FormWrapper from './FormWrapper';
import {Box} from '@chakra-ui/react';
import DateSelector from 'components/DateSelector';

const DatePicker = (props) => {
    const {
        formik,
        i18n,
        index,
        name,
        required = false,
        disabled,
        readOnly,
        minimumDate,
        maximumDate,
        inputProps,
        helper,
        granularity = 'day',
        type,
    } = props;
    const value =
        typeof formik.values[name] === 'string'
            ? parseISO(formik.values[name])
            : formik.values[name];
    return (
        <FormWrapper {...props}>
            <DateSelector
                minDate={minimumDate}
                maxDate={maximumDate}
                isDisabled={disabled}
                value={value}
                onChangeValue={(newValue) =>
                    formik.setFieldValue(name, newValue)
                }
                granularity={granularity}
                hourCycle={24}
            />
        </FormWrapper>
    );
};

// export default DatePicker;

export default React.memo(DatePicker, (prev, next) => {
    const name = prev.name;
    return (
        prev.formik.values[name] === next.formik.values[name] &&
        prev.formik.errors[name] === next.formik.errors[name] &&
        prev.formik.touched[name] === next.formik.touched[name] &&
        prev.disabled === next.disabled &&
        prev.readOnly === next.readOnly &&
        prev.minimumDate === next.minimumDate &&
        prev.maximumDate === next.maximumDate &&
        prev.i18n === next.i18n
    );
});
